// src/components/legajo/LegajoService.js   (o donde guardes tus services)

import axios from 'axios';
import Cookies from 'universal-cookie';
import { SET_LOADING, SET_LEGAJOS, SET_LEGAJO_CABECERA } from "../../../constans/action-types";
import { URL, getAuthorizationHeader } from '../../../constans/constants';
import { logout } from '../../login/SesionService';


const cookies = new Cookies();

export const setLoading = payload => ({ type: SET_LOADING, payload });
export const setLegajos = payload => ({ type: SET_LEGAJOS, payload });
export const setLegajoCabecera = payload => ({ type: SET_LEGAJO_CABECERA, payload });

// ============================
// Helpers
// ============================
const handle401 = (error) => {
  if (error?.response?.status === 401) logout();
  return error;
};

const getEmpresaId = () => cookies.get('empresa');

const buildMultipartConfig = () => {
  const auth = getAuthorizationHeader();
  const headers = { ...(auth.headers || {}) };

  // 🔥 IMPORTANTÍSIMO: no forzar content-type
  delete headers["Content-Type"];
  delete headers["content-type"];

  return { ...auth, headers };
};

const postMultipart = (url, formData) =>
  axios.post(url, formData, buildMultipartConfig());

const putMultipart = (url, formData) =>
  axios.put(url, formData, buildMultipartConfig());

// ============================
// LISTADO / CABECERA
// ============================

/**
 * GET /legajo/listar/{idEmpresa}?search=
 * Devuelve lista (no paginada). Si luego lo paginás, lo adaptamos.
 */
export const getLegajos = (page = 0, size = 5, search = "") => {
  return dispatch => {
    dispatch(setLoading(true));

    const idEmpresa = getEmpresaId();
    const params = [`page=${page}`, `size=${size}`];
    if (search != null && search !== '') params.push(`search=${encodeURIComponent(search)}`);

    const urlRequest = URL + `legajo/listar/${idEmpresa}?${params.join("&")}`;

    return axios.get(urlRequest, getAuthorizationHeader())
            .then(res => {
              dispatch(setLegajos({
                page: res.data.page.pageable.pageNumber,
                totalCount: res.data.page.totalElements,
                legajos: res.data.page.content
              }));
            }, error => {
              if (error.response.status === 401) {
                logout();
              }
              return error;
            });
  };
};

/**
 * POST /legajo/crear/miembro/{miembroId}
 * Crea si no existe y retorna legajoId en response.data.datos
 */
export const crearLegajoSiNoExiste = (miembroId) => {
  return dispatch => {
    dispatch(setLoading(true));

    return axios.post(URL + `legajo/crear/miembro/${miembroId}`, {}, getAuthorizationHeader())
      .then(res => {
        dispatch(setLoading(false));
        return res.data; // ResponseBase<Long>
      }, error => {
        dispatch(setLoading(false));
        return handle401(error);
      });
  };
};

/**
 * GET /legajo/{legajoId}/cabecera
 */
export const obtenerCabeceraLegajo = (legajoId) => {
  return dispatch => {
    dispatch(setLoading(true));

    return axios.get(URL + `legajo/${legajoId}/cabecera`, getAuthorizationHeader())
      .then(res => {
        dispatch(setLoading(false));
        dispatch(setLegajoCabecera(res.data?.datos || null));
        return res.data; // ResponseBase<LegajoDetalleDTO>
      }, error => {
        dispatch(setLoading(false));
        return handle401(error);
      });
  };
};

/**
 * DELETE /legajo/{legajoId}
 */
export const bajaLegajo = (legajoId) => {
  return dispatch => {
    dispatch(setLoading(true));

    return axios.delete(URL + `legajo/${legajoId}`, getAuthorizationHeader())
      .then(res => {
        dispatch(setLoading(false));
        return res.data; // ResponseBase<String>
      }, error => {
        dispatch(setLoading(false));
        return handle401(error);
      });
  };
};

// ============================
// DATOS PERSONALES
// ============================

export const obtenerDatosPersonales = (legajoId) => {
  return dispatch => {
    dispatch(setLoading(true));

    return axios.get(URL + `legajo/${legajoId}/datos-personales`, getAuthorizationHeader())
      .then(res => {
        dispatch(setLoading(false));
        return res.data; // ResponseBase<LegajoDatosPersonalesDTO>
      }, error => {
        dispatch(setLoading(false));
        return handle401(error);
      });
  };
};

export const guardarDatosPersonales = (legajoId, datosPersonales) => {
  return dispatch => {
    dispatch(setLoading(true));

    return axios.post(URL + `legajo/${legajoId}/datos-personales`, datosPersonales, getAuthorizationHeader())
      .then(res => {
        dispatch(setLoading(false));
        return res.data; // ResponseBase<String>
      }, error => {
        dispatch(setLoading(false));
        return handle401(error);
      });
  };
};

// ============================
// CRUD GENERICO POR SECCION
// ============================

/**
 * Helpers para no repetir 50 veces.
 * section: "documentos" | "academicos" | "capacitaciones" | "experiencias" | "cargos" | "evaluaciones" | "telefonos" | "correos" | "redes"
 */
const listSection = (legajoId, section) =>
  axios.get(URL + `legajo/${legajoId}/${section}`, getAuthorizationHeader());

const addSection = (legajoId, section, payload) =>
  axios.post(URL + `legajo/${legajoId}/${section}`, payload, getAuthorizationHeader());

const updateSection = (legajoId, section, id, payload) =>
  axios.put(URL + `legajo/${legajoId}/${section}/${id}`, payload, getAuthorizationHeader());

const deleteSection = (legajoId, section, id) =>
  axios.delete(URL + `legajo/${legajoId}/${section}/${id}`, getAuthorizationHeader());

// ============================
// DOCUMENTOS
// ============================

export const getDocumentos = (legajoId) => {
  return dispatch => {
    dispatch(setLoading(true));
    return listSection(legajoId, "documentos")
      .then(res => { dispatch(setLoading(false)); return res.data; },
        error => { dispatch(setLoading(false)); return handle401(error); });
  };
};

export const registrarDocumento = (legajoId, data, esMultipart = false) => {
  console.log("es FormData?", data instanceof FormData);
console.log("headers auth:", getAuthorizationHeader().headers);
  const url = `${URL}legajo/${legajoId}/documentos`;
  if (esMultipart) return postMultipart(url, data);
  return axios.post(url, data, getAuthorizationHeader());
};

export const editarDocumento = (legajoId, rowId, data, esMultipart = false) => {
  const url = `${URL}legajo/${legajoId}/documentos/${rowId}`;
  if (esMultipart) return putMultipart(url, data);
  return axios.put(url, data, getAuthorizationHeader());
};


export const eliminarDocumento = (legajoId, id) => {
  return dispatch => {
    dispatch(setLoading(true));
    return deleteSection(legajoId, "documentos", id)
      .then(res => { dispatch(setLoading(false)); return res.data; },
        error => { dispatch(setLoading(false)); return handle401(error); });
  };
};

// ============================
// ACADEMICOS
// ============================

export const getAcademicos = (legajoId) => {
  return dispatch => {
    dispatch(setLoading(true));
    return listSection(legajoId, "academicos")
      .then(res => { dispatch(setLoading(false)); return res.data; },
        error => { dispatch(setLoading(false)); return handle401(error); });
  };
};

export const registrarAcademico = (legajoId, payload) => {
  return dispatch => {
    dispatch(setLoading(true));

    const isMultipart = payload instanceof FormData;

    const req = isMultipart
      ? postMultipart(`${URL}legajo/${legajoId}/academicos`, payload)
      : addSection(legajoId, "academicos", payload);

    return req.then(
      res => { dispatch(setLoading(false)); return res.data; },
      error => { dispatch(setLoading(false)); return handle401(error); }
    );
  };
};

export const editarAcademico = (legajoId, id, payload) => {
  return dispatch => {
    dispatch(setLoading(true));

    const isMultipart = payload instanceof FormData;

    const req = isMultipart
      ? putMultipart(`${URL}legajo/${legajoId}/academicos/${id}`, payload)
      : updateSection(legajoId, "academicos", id, payload);

    return req.then(
      res => { dispatch(setLoading(false)); return res.data; },
      error => { dispatch(setLoading(false)); return handle401(error); }
    );
  };
};


export const eliminarAcademico = (legajoId, id) => {
  return dispatch => {
    dispatch(setLoading(true));
    return deleteSection(legajoId, "academicos", id)
      .then(res => { dispatch(setLoading(false)); return res.data; },
        error => { dispatch(setLoading(false)); return handle401(error); });
  };
};

// ============================
// CAPACITACIONES
// ============================

export const getCapacitaciones = (legajoId) => {
  return dispatch => {
    dispatch(setLoading(true));
    return listSection(legajoId, "capacitaciones")
      .then(res => { dispatch(setLoading(false)); return res.data; },
        error => { dispatch(setLoading(false)); return handle401(error); });
  };
};

export const registrarCapacitacion = (legajoId, payload) => {
  return dispatch => {
    dispatch(setLoading(true));

    const isMultipart = payload instanceof FormData;

    const req = isMultipart
      ? postMultipart(`${URL}legajo/${legajoId}/capacitaciones`, payload)
      : addSection(legajoId, "capacitaciones", payload);

    return req.then(
      res => { dispatch(setLoading(false)); return res.data; },
      error => { dispatch(setLoading(false)); return handle401(error); }
    );
  };
};

export const editarCapacitacion = (legajoId, id, payload) => {
  return dispatch => {
    dispatch(setLoading(true));

    const isMultipart = payload instanceof FormData;

    const req = isMultipart
      ? putMultipart(`${URL}legajo/${legajoId}/capacitaciones/${id}`, payload)
      : updateSection(legajoId, "capacitaciones", id, payload);

    return req.then(
      res => { dispatch(setLoading(false)); return res.data; },
      error => { dispatch(setLoading(false)); return handle401(error); }
    );
  };
};


export const eliminarCapacitacion = (legajoId, id) => {
  return dispatch => {
    dispatch(setLoading(true));
    return deleteSection(legajoId, "capacitaciones", id)
      .then(res => { dispatch(setLoading(false)); return res.data; },
        error => { dispatch(setLoading(false)); return handle401(error); });
  };
};

// ============================
// EXPERIENCIAS
// ============================

export const getExperiencias = (legajoId) => {
  return dispatch => {
    dispatch(setLoading(true));
    return listSection(legajoId, "experiencias")
      .then(res => { dispatch(setLoading(false)); return res.data; },
        error => { dispatch(setLoading(false)); return handle401(error); });
  };
};

export const registrarExperiencia = (legajoId, payload) => {
  return dispatch => {
    dispatch(setLoading(true));
    return addSection(legajoId, "experiencias", payload)
      .then(res => { dispatch(setLoading(false)); return res.data; },
        error => { dispatch(setLoading(false)); return handle401(error); });
  };
};

export const editarExperiencia = (legajoId, id, payload) => {
  return dispatch => {
    dispatch(setLoading(true));
    return updateSection(legajoId, "experiencias", id, payload)
      .then(res => { dispatch(setLoading(false)); return res.data; },
        error => { dispatch(setLoading(false)); return handle401(error); });
  };
};

export const eliminarExperiencia = (legajoId, id) => {
  return dispatch => {
    dispatch(setLoading(true));
    return deleteSection(legajoId, "experiencias", id)
      .then(res => { dispatch(setLoading(false)); return res.data; },
        error => { dispatch(setLoading(false)); return handle401(error); });
  };
};

// ============================
// CARGOS
// ============================

export const getCargos = (legajoId) => {
  return dispatch => {
    dispatch(setLoading(true));
    return listSection(legajoId, "cargos")
      .then(res => { dispatch(setLoading(false)); return res.data; },
        error => { dispatch(setLoading(false)); return handle401(error); });
  };
};

export const registrarCargo = (legajoId, payload) => {
  return dispatch => {
    dispatch(setLoading(true));
    return addSection(legajoId, "cargos", payload)
      .then(res => { dispatch(setLoading(false)); return res.data; },
        error => { dispatch(setLoading(false)); return handle401(error); });
  };
};

export const editarCargo = (legajoId, id, payload) => {
  return dispatch => {
    dispatch(setLoading(true));
    return updateSection(legajoId, "cargos", id, payload)
      .then(res => { dispatch(setLoading(false)); return res.data; },
        error => { dispatch(setLoading(false)); return handle401(error); });
  };
};

export const eliminarCargo = (legajoId, id) => {
  return dispatch => {
    dispatch(setLoading(true));
    return deleteSection(legajoId, "cargos", id)
      .then(res => { dispatch(setLoading(false)); return res.data; },
        error => { dispatch(setLoading(false)); return handle401(error); });
  };
};

// ============================
// EVALUACIONES
// ============================

export const getEvaluaciones = (legajoId) => {
  return dispatch => {
    dispatch(setLoading(true));
    return listSection(legajoId, "evaluaciones")
      .then(res => { dispatch(setLoading(false)); return res.data; },
        error => { dispatch(setLoading(false)); return handle401(error); });
  };
};

export const registrarEvaluacion = (legajoId, payload) => {
  return dispatch => {
    dispatch(setLoading(true));
    return addSection(legajoId, "evaluaciones", payload)
      .then(res => { dispatch(setLoading(false)); return res.data; },
        error => { dispatch(setLoading(false)); return handle401(error); });
  };
};

export const editarEvaluacion = (legajoId, id, payload) => {
  return dispatch => {
    dispatch(setLoading(true));
    return updateSection(legajoId, "evaluaciones", id, payload)
      .then(res => { dispatch(setLoading(false)); return res.data; },
        error => { dispatch(setLoading(false)); return handle401(error); });
  };
};

export const eliminarEvaluacion = (legajoId, id) => {
  return dispatch => {
    dispatch(setLoading(true));
    return deleteSection(legajoId, "evaluaciones", id)
      .then(res => { dispatch(setLoading(false)); return res.data; },
        error => { dispatch(setLoading(false)); return handle401(error); });
  };
};

// ============================
// TELEFONOS
// ============================

export const getTelefonos = (legajoId) => {
  return dispatch => {
    dispatch(setLoading(true));
    return listSection(legajoId, "telefonos")
      .then(res => { dispatch(setLoading(false)); return res.data; },
        error => { dispatch(setLoading(false)); return handle401(error); });
  };
};

export const registrarTelefono = (legajoId, payload) => {
  return dispatch => {
    dispatch(setLoading(true));
    return addSection(legajoId, "telefonos", payload)
      .then(res => { dispatch(setLoading(false)); return res.data; },
        error => { dispatch(setLoading(false)); return handle401(error); });
  };
};

export const editarTelefono = (legajoId, id, payload) => {
  return dispatch => {
    dispatch(setLoading(true));
    return updateSection(legajoId, "telefonos", id, payload)
      .then(res => { dispatch(setLoading(false)); return res.data; },
        error => { dispatch(setLoading(false)); return handle401(error); });
  };
};

export const eliminarTelefono = (legajoId, id) => {
  return dispatch => {
    dispatch(setLoading(true));
    return deleteSection(legajoId, "telefonos", id)
      .then(res => { dispatch(setLoading(false)); return res.data; },
        error => { dispatch(setLoading(false)); return handle401(error); });
  };
};

// ============================
// CORREOS
// ============================

export const getCorreos = (legajoId) => {
  return dispatch => {
    dispatch(setLoading(true));
    return listSection(legajoId, "correos")
      .then(res => { dispatch(setLoading(false)); return res.data; },
        error => { dispatch(setLoading(false)); return handle401(error); });
  };
};

export const registrarCorreo = (legajoId, payload) => {
  return dispatch => {
    dispatch(setLoading(true));
    return addSection(legajoId, "correos", payload)
      .then(res => { dispatch(setLoading(false)); return res.data; },
        error => { dispatch(setLoading(false)); return handle401(error); });
  };
};

export const editarCorreo = (legajoId, id, payload) => {
  return dispatch => {
    dispatch(setLoading(true));
    return updateSection(legajoId, "correos", id, payload)
      .then(res => { dispatch(setLoading(false)); return res.data; },
        error => { dispatch(setLoading(false)); return handle401(error); });
  };
};

export const eliminarCorreo = (legajoId, id) => {
  return dispatch => {
    dispatch(setLoading(true));
    return deleteSection(legajoId, "correos", id)
      .then(res => { dispatch(setLoading(false)); return res.data; },
        error => { dispatch(setLoading(false)); return handle401(error); });
  };
};

// ============================
// REDES
// ============================

export const getRedes = (legajoId) => {
  return dispatch => {
    dispatch(setLoading(true));
    return listSection(legajoId, "redes")
      .then(res => { dispatch(setLoading(false)); return res.data; },
        error => { dispatch(setLoading(false)); return handle401(error); });
  };
};

export const registrarRed = (legajoId, payload) => {
  return dispatch => {
    dispatch(setLoading(true));
    return addSection(legajoId, "redes", payload)
      .then(res => { dispatch(setLoading(false)); return res.data; },
        error => { dispatch(setLoading(false)); return handle401(error); });
  };
};

export const editarRed = (legajoId, id, payload) => {
  return dispatch => {
    dispatch(setLoading(true));
    return updateSection(legajoId, "redes", id, payload)
      .then(res => { dispatch(setLoading(false)); return res.data; },
        error => { dispatch(setLoading(false)); return handle401(error); });
  };
};

export const eliminarRed = (legajoId, id) => {
  return dispatch => {
    dispatch(setLoading(true));
    return deleteSection(legajoId, "redes", id)
      .then(res => { dispatch(setLoading(false)); return res.data; },
        error => { dispatch(setLoading(false)); return handle401(error); });
  };
};

export const importarLegajosDesdeMiembros = () => {
  const idEmpresa = getEmpresaId();
  return axios.post(
    `${URL}legajo/empresa/${idEmpresa}/importar-desde-miembros`,
    {}, // body vacío
    getAuthorizationHeader()
  );
};

// ============================
// FILES
// ============================


export const descargarLegajoFile = (fileId) => {
  return axios.get(`${URL}legajo/files/${fileId}`, {
    ...getAuthorizationHeader(),
    responseType: "blob",
  });
};

// ============================
// DÍAS LABORALES
// ============================

export const getDiasLaborales = (legajoId) =>
  axios.get(`${URL}legajo/${legajoId}/dias-laborales`, getAuthorizationHeader());

export const setDiasLaborales = (legajoId, mask) =>
  axios.put(`${URL}legajo/${legajoId}/dias-laborales`, mask, getAuthorizationHeader());